// Iconos propios (trazo de 1.8, 24×24), sin dependencia externa. Decorativos: aria-hidden siempre;
// el nombre accesible lo pone el control que los contiene.
import type { ReactNode, SVGProps } from 'react';

function Icon({ children, ...props }: SVGProps<SVGSVGElement> & { children: ReactNode }) {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth={1.8}
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}>
      {children}
    </svg>
  );
}

type P = SVGProps<SVGSVGElement>;

export const IconInbox = (p: P) => (
  <Icon {...p}><path d="M3 13h5l1.5 3h5L16 13h5" /><path d="M5.5 5h13L21 13v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5z" /></Icon>
);
export const IconSearch = (p: P) => (
  <Icon {...p}><circle cx="11" cy="11" r="6.5" /><path d="m20 20-4.2-4.2" /></Icon>
);
export const IconSend = (p: P) => (
  <Icon {...p}><path d="M4 12 20 4l-4 16-4.5-6.5z" /><path d="M11.5 13.5 20 4" /></Icon>
);
export const IconBack = (p: P) => (
  <Icon {...p}><path d="M15 5 8 12l7 7" /></Icon>
);
export const IconClock = (p: P) => (
  <Icon {...p}><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></Icon>
);
export const IconLogout = (p: P) => (
  <Icon {...p}><path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" /><path d="M10 16l-4-4 4-4" /><path d="M6 12h10" /></Icon>
);
export const IconHand = (p: P) => (
  <Icon {...p}><path d="M8 13V6.5a1.5 1.5 0 0 1 3 0V12" /><path d="M11 11V5a1.5 1.5 0 0 1 3 0v6" /><path d="M14 11V6.5a1.5 1.5 0 0 1 3 0V14a6 6 0 0 1-6 6h-.5a6 6 0 0 1-5-2.7L4 15a1.5 1.5 0 0 1 2.5-1.7L8 15" /></Icon>
);
export const IconPause = (p: P) => (
  <Icon {...p}><circle cx="12" cy="12" r="8.5" /><path d="M10 9v6M14 9v6" /></Icon>
);
export const IconCheck = (p: P) => (
  <Icon {...p}><circle cx="12" cy="12" r="8.5" /><path d="m8.5 12.2 2.4 2.3 4.6-4.9" /></Icon>
);
export const IconReopen = (p: P) => (
  <Icon {...p}><path d="M4 12a8 8 0 1 0 2.4-5.7" /><path d="M4 4v4h4" /></Icon>
);
export const IconAlert = (p: P) => (
  <Icon {...p}><path d="M12 4 2.8 19.5h18.4z" /><path d="M12 10v4.2M12 17.2v.1" /></Icon>
);
export const IconLock = (p: P) => (
  <Icon {...p}><rect x="5" y="10.5" width="14" height="9.5" rx="2" /><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" /></Icon>
);
export const IconLink = (p: P) => (
  <Icon {...p}><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" /><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" /></Icon>
);
export const IconSun = (p: P) => (
  <Icon {...p}><circle cx="12" cy="12" r="4" /><path d="M12 2.5v2M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4" /></Icon>
);
export const IconMoon = (p: P) => (
  <Icon {...p}><path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" /></Icon>
);
export const IconMonitor = (p: P) => (
  <Icon {...p}><rect x="3" y="4.5" width="18" height="12" rx="2" /><path d="M8.5 20h7M12 16.5V20" /></Icon>
);
export const IconTick = (p: P) => (
  <Icon {...p}><path d="m5 12.5 4.5 4.5L19 7.5" /></Icon>
);
export const IconClip = (p: P) => (
  <Icon {...p}><path d="m20 11.5-7.8 7.8a5 5 0 0 1-7.1-7.1l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7L9.8 16.9a1.7 1.7 0 0 1-2.4-2.4l7.1-7.1" /></Icon>
);
export const IconTemplate = (p: P) => (
  <Icon {...p}><rect x="4" y="4" width="16" height="16" rx="2.5" /><path d="M8 9h8M8 13h8M8 17h5" /></Icon>
);
export const IconPlug = (p: P) => (
  <Icon {...p}><path d="M9 3.5v4M15 3.5v4" /><path d="M6.5 7.5h11v3a5.5 5.5 0 0 1-11 0z" /><path d="M12 16v4.5" /></Icon>
);
export const IconUsers = (p: P) => (
  <Icon {...p}><circle cx="9" cy="8.5" r="3.2" /><path d="M3.5 19a5.5 5.5 0 0 1 11 0" /><path d="M15.5 5.6a3.2 3.2 0 0 1 0 5.8" /><path d="M17.5 14.2a5.5 5.5 0 0 1 3 4.8" /></Icon>
);
export const IconUnlink = (p: P) => (
  <Icon {...p}><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-4.2-6.6" /><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 4.2 6.6" /><path d="M4 4l16 16" /></Icon>
);
export const IconShield = (p: P) => (
  <Icon {...p}><path d="M12 3.5 19 6v5.5c0 4.2-2.9 7.7-7 9-4.1-1.3-7-4.8-7-9V6z" /><path d="m9 12 2.2 2.2L15.5 10" /></Icon>
);
export const IconKey = (p: P) => (
  <Icon {...p}><circle cx="8" cy="15" r="4" /><path d="m11 12 8.5-8.5" /><path d="m16.5 6.5 2.5 2.5" /><path d="m14 9 2 2" /></Icon>
);
export const IconPencil = (p: P) => (
  <Icon {...p}><path d="M4 20h4L19 9l-4-4L4 16z" /><path d="m13.5 6.5 4 4" /></Icon>
);
export const IconUserPlus = (p: P) => (
  <Icon {...p}><circle cx="10" cy="8" r="3.5" /><path d="M3.5 20a6.5 6.5 0 0 1 13 0" /><path d="M19 8v6" /><path d="M16 11h6" /></Icon>
);
export const IconBoard = (p: P) => (
  <Icon {...p}><rect x="3.5" y="4" width="17" height="16" rx="2.5" /><path d="M9.2 4v16M14.8 4v16" /><path d="M5.8 8h1.4M11.3 8h1.4M11.3 11.5h1.4M16.8 8h1.4" /></Icon>
);
export const IconTrash = (p: P) => (
  <Icon {...p}><path d="M4.5 7h15" /><path d="M9.5 7V4.8h5V7" /><path d="M6.5 7l.9 12.2h9.2L17.5 7" /><path d="M10.2 10.5v5.5M13.8 10.5v5.5" /></Icon>
);
export const IconFlag = (p: P) => (
  <Icon {...p}><path d="M5.5 21V4" /><path d="M5.5 4.5h11l-2.2 4 2.2 4h-11" /></Icon>
);
export const IconFolder = (p: P) => (
  <Icon {...p}><path d="M3.5 7a2 2 0 0 1 2-2h4l2 2.2h7a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" /></Icon>
);
export const IconCalendar = (p: P) => (
  <Icon {...p}><rect x="3.5" y="5" width="17" height="15" rx="2.5" /><path d="M3.5 10h17M8 3v4M16 3v4" /></Icon>
);
export const IconMegaphone = (p: P) => (
  <Icon {...p}><path d="M4 10v4a1 1 0 0 0 1 1h2.5L14 19V5L7.5 9H5a1 1 0 0 0-1 1z" /><path d="M17.5 9.5a3.5 3.5 0 0 1 0 5" /><path d="M8 15.5 9 20" /></Icon>
);
export const IconProgress = (p: P) => (
  <Icon {...p}><circle cx="12" cy="12" r="8.5" /><path d="M12 7v5l3 2" /></Icon>
);
export const IconPerson = (p: P) => (
  <Icon {...p}><circle cx="12" cy="8.5" r="3.6" /><path d="M5.5 20a6.5 6.5 0 0 1 13 0" /></Icon>
);
export const IconMore = (p: P) => (
  <Icon {...p}><circle cx="5.5" cy="12" r="1.3" fill="currentColor" stroke="none" /><circle cx="12" cy="12" r="1.3" fill="currentColor" stroke="none" /><circle cx="18.5" cy="12" r="1.3" fill="currentColor" stroke="none" /></Icon>
);
export const IconPlus = (p: P) => (
  <Icon {...p}><path d="M12 5v14M5 12h14" /></Icon>
);
export const IconChevron = (p: P) => (
  <Icon {...p}><path d="m6 9 6 6 6-6" /></Icon>
);
export const IconInfo = (p: P) => (
  <Icon {...p}><circle cx="12" cy="12" r="8.5" /><path d="M12 11v5" /><path d="M12 7.6v.1" /></Icon>
);
